import React from 'react';

const Logo = () => {
  return (
    <div className="logo">Closet.io</div>
  )
}

export default Logo;